import React from 'react';
import { TypedMemo } from '../../../common/types';
import { LoadingView } from '../../../common/views/LoadingView';
import { useAccountId } from '../../../../redux/slices/appInfo/hooks';
import { PromoteComposerScreen } from './PromoteComposerScreen';

/** The Promote / Composer route. Every call is account-scoped. */
const PromoteComposerViewComponent: React.FC = () => {
  const accountId = useAccountId();

  if (accountId === null) {
    return <LoadingView />;
  }

  return <PromoteComposerScreen accountId={accountId} />;
};

export const PromoteComposerView = TypedMemo(PromoteComposerViewComponent);
